<script lang="ts" setup>
import type {
  MagentoCartItemInput,
  MagentoConfigurableProductCartItemInput,
  MagentoProduct,
} from '~layers/app/types/magento'

import {
  ProductConfigurable,
  ProductGrouped,
  ProductBundle,
  ProductSimple,
} from '#components'

export interface Props {
  product: MagentoProduct
}

const props = defineProps<Props>()

const emit = defineEmits<{
  selected: Record<string, MagentoCartItemInput | MagentoConfigurableProductCartItemInput>
}>()

const getComponent = computed(() => {
  switch (props.product.__typename) {
    case 'ConfigurableProduct': return ProductConfigurable
    case 'GroupedProduct': return ProductGrouped
    case 'BundleProduct': return ProductBundle
    default: return ProductSimple
  }
})

const selected = (item: Record<string, MagentoCartItemInput>) => {
  emit('selected', item)
}
</script>

<template>
  <component
    :is="getComponent"
    :product="product"
    @selected="selected"
  >
    <template #oos="slotProps">
      <slot
        name="oos"
        v-bind="slotProps"
      />
    </template>
  </component>
</template>
